export default __webpack_public_path__ + "static/media/obc-logo.6d58ebc2.png";